// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconInspectPath = 'M6.269 11.5a6.956 6.956 0 0 1-1.264-4c0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7s-3.141 7-7 7a6.953 6.953 0 0 1-3.404-.889l.426 1.542-2.7 3.291A3.018 3.018 0 0 1 4.09 19.5h-.034a3.005 3.005 0 0 1-2.945-3.054c.014-.681.26-1.343.695-1.865l2.49-3.081H6.27Zm-2.194 6a1 1 0 0 0 .724-.345l2.023-2.468-.328-1.187H5.252l-1.9 2.349a1.001 1.001 0 0 0 .723 1.651Zm2.93-10c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5ZM10 7.5a2 2 0 1 1 4.002.001A2 2 0 0 1 10 7.5Z';
var IconInspect = baseIcon('IconInspect', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconInspectPath
});
export default IconInspect;
//# sourceMappingURL=index.js.map